/* eslint-disable react/forbid-dom-props */
/**
 * Banner component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

export default class Banner extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        banner: PropTypes.object,
        data: PropTypes.object,
        settings: PropTypes.object,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        banner: {},
        data: {},
        settings: {},
    };

    /**
     * @type {Object}
     */
    state = {};

    render () {
        const {
            banner,
            data,
            settings,
        } = this.props;
        const image = banner.src;

        if (!image) {
            return null;
        }

        return (
            <div
                className={ cx('registration-site-banner', { 'registration-site-banner--full': settings.full }) }
            >
                <div className="registration-site-banner-container">
                    <div className="registration-site-banner-container-image">
                        <img
                            src={ image }
                            alt={ data.name }
                        />
                    </div>

                    { data &&
                    <div className="registration-site-banner-container-text-wrapper clearfix">
                        <div className="registration-site-banner-container-text">
                            { !settings.hideDetailsName && <h1 style={ { fontSize: settings.nameSize } }>
                                { data.name }
                            </h1> }
                            { !settings.hideDetailsDates && data.dateStart && <h5>
                                { !data.dateEnd &&
                                <span><FormattedMessage id="registration.date"/>: </span> }
                                { data.dateStart }
                                { data.dateEnd && ' - ' }
                                { data.dateEnd }
                            </h5> }
                            { !settings.hideDetailsLocation && data.location &&
                            <h5><FormattedMessage id="registration.location"/>: { data.location }</h5> }
                        </div>
                    </div> }
                </div>
            </div>
        );
    }
}
